import { VehicleTypeEnum } from "./vehicle-type";

export class NotificationMessage {
  id: number;
  title: string;
  main: string;
  submain: string;
  type: string;
  notificationType?: NotificationType;
  data?: { [key: string]: unknown };
  infoList? : { label: string; value: string }[];
  link: string;
  groups: string[];
  isRead: boolean;
  created: Date;

  constructor(
    id: number,
    title: string,
    main: string,
    submain: string,
    type: string,
    link: string,
    groups: string[],
    isRead: boolean,
    created: Date,
    notificationType?: NotificationType,
    data?: { [key: string]: unknown }
  ) {
    this.id = id;
    this.title = title;
    this.main = main;
    this.submain = submain;
    this.type = type;
    this.notificationType = notificationType;
    this.data = data;
    this.link = link;
    this.groups = groups;
    this.isRead = isRead;
    this.created = created;
  }
}

export enum NotificationType {
  DriveOrderInquiryCreated = 1,
  DriveOrderAssigned = 2,
  DriveOrderActivationReminderToSubcontractor = 3,
  PossibleLateFirstDeparture = 4,
  OrderCreated = 5,
  OrderEdited = 6,
  OrderCancelled = 7,
  DriverMessageOnTripStopUpdated = 8,
  DriveOrderCancelled = 9,
  DriveOrderTripsCancelled = 10,
  DriveOrderSubcontractorChanged = 11,
  DriveOrderTripsReplaced = 12,
  DriveOrderTripsDuplicated = 13,
  DriveOrderDuplicated = 14,
  DriveOrderInquiryReply = 15,
  IntegrationErrorDriveOrderCreationFailed = 16,
  IntegrationErrorInvalidStartPlaceForSubcontractor = 17,
  IntegrationErrorNotFoundAddresses = 18,
  IntegrationErrorInvalidVehicleType = 19,
  IntegrationErrorUnsupportedVehicleSize = 20,
  DriveOrderCancelledRequiresManualHandling = 21,
}

export interface DriveOrderInquiryCreated {
  numberOfInquiries: number;
}

export interface DriveOrderInquiryReply {
  orderId: number;
  driveOrderId: number;
  subcontractorId: number;
  subcontractorName: string;
  startPlaceDescription: string;
  endPlaceDescription: string;
  inquiryStatus: string;
  isProductBased: boolean;
}

export interface DriveOrderAssigned {
  numberOfDriveOrders: number;
}

export interface DriveOrderTripsCancelled {
  orderId: number;
  driveOrderId: number;
  isSingleTrip: boolean;
  tripId: number;
  startStopPasstime: string;
  startStopDescription: string;
}

export interface DriveOrderDuplicated {
  orderId: number;
  driveOrderId: number;
  newDriveOrderId: number;
}

export interface DriveOrderTripsDuplicated {
  orderId: number;
  driveOrderId: number;
  newDriveOrderId: number;
  isSingleTrip: boolean;
}

export interface DriveOrderTripsReplaced {
  orderId: number;
  driveOrderId: number;
  newDriveOrderId: number;
}

export interface DriveOrderSubcontractorChanged {
  orderId: number;
  driveOrderId: number;
  subcontractorName: string;
}

export interface DriveOrderCancelledRequiresManualHandling {  
  orderId: number;
  driveOrderId: number;
}

export interface DriveOrderActivationReminderToSubcontractor {
  subcontractorId: number;
  subcontractorOrderId: number;
  driveOrderId: number;
  driverFullName: string;
  startTime: Date;
}

export interface DriverMessageOnTripStopUpdated{
  operatorName: string;
  placeName: string;
  placeDescription: string;
  passTime: Date;
  tripId: number;
  driveOrderId: number;
  orderId: number;
  driverFullName: string;
  driverPhoneNumber: string;
  message: string;
}

export interface PossibleLateFirstDeparture {
  orderId: number;
  driveOrderId: number;
  tripId: number;
  startTripStopTime: Date;
}

export interface OrderCreated {
  orderId: number;
  operatorName: string;
  orderType: string;
  isProductBased: boolean;
  routeName: string | null;
  routeStartPlaceDescription: string | null;
  routeEndPlaceDescription: string | null;
}

export interface OrderEdited {
  orderId: number;
  operatorName: string;
  orderType: string;
  isProductBased: boolean;
  routeName: string | null;
  routeStartPlaceDescription: string | null;
  routeEndPlaceDescription: string | null;
}

export interface OrderCancelled {
  orderId: number;
  operatorName: string;
  orderType: string;
  isProductBased: boolean;
  routeName: string | null;
  routeStartPlaceDescription: string | null;
  routeEndPlaceDescription: string | null;
}

interface UserMessageOnIntegrationError {
  orderId: number;
  driveOrderId: number;
  tripId: number;
  initiatingIdentitySecurityIdentifier: string;
  initiatingIdentityName: string;
}

export interface UserMessageOnIntegrationErrorDriveOrderCreationFailed extends UserMessageOnIntegrationError {
  errorMessage: string;
}

export interface UserMessageOnIntegrationErrorInvalidStartPlaceForSubcontractor extends UserMessageOnIntegrationError {
  subcontractorId: number;
  subcontractorName: string;
  placeId: number;
  placeName: string;
}

export interface UserMessageOnIntegrationErrorNotFoundAddresses extends UserMessageOnIntegrationError {
  subcontractorId: number;
  subcontractorName: string;
  placeNames: string[];
}

export interface UserMessageOnIntegrationErrorInvalidVehicleType extends UserMessageOnIntegrationError {
  subcontractorId: number;
  subcontractorName: string;
  vehicleType: VehicleTypeEnum;
}

export interface UserMessageOnIntegrationErrorUnsupportedVehicleSize extends UserMessageOnIntegrationError {
  subcontractorId: number;
  subcontractorName: string;
  supportedMaxSize: number;
  vehicleType: VehicleTypeEnum;
  vehicleTypeSize: number;
}